import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getOfficeType = async () => {
  const { data } = await axios.get(`${api_base_url}/OfficeType/OfficeType`);
  return data;
};
export const addOfficeType = async (newOfficeType) => {
  const { data } = await axios.post(`${api_base_url}/OfficeType`, {
    ...newOfficeType[0],
  });
  return data;
};
export const updateOfficeType = async (updatedOfficeType) => {
  const { data } = await axios.put(
    `${api_base_url}/OfficeType/${updatedOfficeType[0].officeTypeId}`,
    updatedOfficeType[0]
  );
  return data;
};

export const deleteOfficeType = async (ids) => {
  await axios.delete(`${api_base_url}/OfficeType`, {
    data: ids,
  });
};

//Search OfficeType
export const searchOfficeType = async (searchInputsData) => {
  if (searchInputsData === "") {
    searchInputsData = "0";
  }
  const data = {
    glNumber: parseInt(searchInputsData),
  };

  return await axios
    .post(`${api_base_url}/OfficeType/SearchOfficeType`, data)
    .then((res) => res.data);
};
